import { h } from '@stencil/core';

const FALLBACK_IMAGE = 'https://media.staticontent.com/media/pictures/614da785-ac28-43eb-b99c-0cf2022d9f68';

type ChatImageProps = {
  src?: string;
  alt?: string;
  fallbackSrc?: string;
  [key: string]: any;
};

export const ChatImage = ({ src, alt = '', fallbackSrc = FALLBACK_IMAGE, ...props }: ChatImageProps) => (
  <img
    src={src || fallbackSrc}
    alt={alt}
    onError={e => {
      (e.target as HTMLImageElement).src = fallbackSrc;
    }}
    {...props}
  />
);
